import { render, staticRenderFns } from "./change-photo-form.vue?vue&type=template&id=7c43f22f"
import script from "./change-photo-form.vue?vue&type=script&lang=js"
export * from "./change-photo-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports